<app-breadcrumb [secondCrumb]="getCrumbName"></app-breadcrumb>

<!-- Large/Extra large/Extra extra large viewport -->
<div
  class="d-none d-lg-block container-fuid ms-2 ms-sm-2 ms-md-4 ms-lg-5 ms-xl-5 ms-xxl-5 me-2 me-sm-2 me-md-4 me-lg-5 me-xl-5 me-xxl-5 default-boxshadow mt-2 mt-4 bg-white default-boxrounded p-0">
  <div class="bg-white default-boxrounded">
    <app-requestheader [request]="request" [workflowData]="workflowData!" #header>
    </app-requestheader>
    <div class="px-4 pb-4">
      <app-request-title [request]="request"></app-request-title>
      <div class="d-none d-lg-block p-0">
        <hr class="hr">
      </div>
      <!-- STEP 1 - DOCUMENTS -->
      <app-add-document
        [hidden]="(workflowData && workflowData.step1 && workflowData.step1.skipStep) || currentTab !== 'AddDocuments'"
        #addDocument [showKvKError]="(workflowData?.requireKVK && !organisationHasKVK)"
        (AddMyselfEmitter)="addPersons.addMyself()"
        (LoadThumbnail)="getThumbnailAddDocument($event)"></app-add-document>

      <!-- STEP 2 - PERSONS -->
      <app-add-persons
        [hidden]="(workflowData && workflowData.step2 && workflowData.step2.skipStep) || currentTab !== 'AddPersons'"
        #addPersons [organisationSettings]="settings" [showMessage]="showMessage" [currentUserAdded]="currentUserAdded"
        [requestId]="requestId" (currentUserAddedChange)="currentUserAddedChange($event)"></app-add-persons>

      <!-- STEP 3 - ACTIONS -->
      <app-step-3
        [hidden]="(workflowData && workflowData.step3 && workflowData.step3.skipStep) || currentTab !== 'AddActions'">
      </app-step-3>
      <!-- <app-add-actions [hidden]="(workflowData && workflowData.step3 && workflowData.step3.skipStep) || currentTab !== 'AddActions'" [request]="request" #addActions [workflowData]="workflowData?.step3" [countDocuments]="countDocuments" [countPersons]="countPersons" [signYourself]="signYourself" (UpdateProgress)="calcProgress()"></app-add-actions> -->

      <!-- STEP 4 - SENDGROUPS -->
      <app-step-4
        [hidden]="(workflowData && workflowData.step4 && workflowData.step4.skipStep) || currentTab !== 'ReviewAndSend'">
      </app-step-4>
      <!-- <app-reviewandsend *ngIf="!((workflowData && workflowData.step4 && workflowData.step4.skipStep) || currentTab !== 'ReviewAndSend')" [request]="request" #reviewAndSend></app-reviewandsend> -->
    </div>
  </div>
</div>


<!-- Small/Medium viewport -->


<!-- 
<div class="d-block d-lg-none container-fuid ms-2 ms-sm-2 ms-md-4 ms-lg-5 ms-xl-5 ms-xxl-5 me-2 me-sm-2 me-md-4 me-lg-5 me-xl-5 me-xxl-5 default-boxshadow mt-2 mt-4 bg-white default-boxrounded p-0" id="accordion">
  <div class="bg-white default-boxrounded">
    <div class="accordion">
      <div class="accordion-item">
          <div class="accordion-header justify-content-between bg-light" id="addDocuments">
            <div class="p-3" data-bs-toggle="collapse" data-bs-target="#addDocuments-panel" aria-expanded="false" aria-controls="addDocuments-panel" (click)="header.getActiveTab('AddDocuments');">
              <h3 class="mb-0 text-primary" [ngClass]="{active : currentTab === 'AddDocuments'}" >
                <i class="bi bi-1-circle-fill text-primary" [ngClass]="{'error' : request.status === 'Error'}"></i>
                <span translate="Request.AddDocuments"></span>
              </h3>
            </div>
          </div>
          <div id="addDocuments-panel" class="accordion-collapse collapse show indent" aria-labelledby="addDocuments" data-bs-parent="#accordion">
            <div class="bg-white accordion-body px-3 pb-4 h-100">
              <app-add-document [hidden]="currentTab !== 'AddDocuments'" [showKvKError]="(workflowData?.requireKVK && !organisationHasKVK())"></app-add-document>
              <app-flow-navigation [request]="request" [currentTab]="currentTab" [currentStep]="currentTab" [disabled]="header.disableNextButton()" [progress]="progress" (activeTab)="header.getActiveTab($event);"></app-flow-navigation>
            </div>
          </div>
      </div>
      <div class="accordion-item" [ngClass]="{disabledDiv : (progress[0] < 100)}">
          <div class="accordion-header justify-content-between bg-light" id="addPersons">
            <div class="p-3" data-bs-toggle="collapse" data-bs-target="#addPersons-panel" aria-expanded="false" aria-controls="addPersons-panel" (click)="header.getActiveTab('AddPersons');">
              <h3 class="mb-0 text-primary" [ngClass]="{active : currentTab === 'AddPersons'}" >
                <i class="bi bi-2-circle-fill text-primary" [ngClass]="{'text-secondary' : (progress[0] < 100)}"></i>
                <span [ngClass]="{'text-secondary' : (progress[0] < 100)}" translate="Request.AddPersons"></span>
              </h3>
            </div>
          </div>
          <div id="addPersons-panel" class="accordion-collapse collapse indent" aria-labelledby="addPersons" data-bs-parent="#accordion">
            <div class="bg-white accordion-body px-3 pb-4 h-100">
              <app-add-persons [hidden]="currentTab !== 'AddPersons'" [organisationSettings]="settings" [showMessage]="showMessage" [currentUserAdded]="currentUserAdded" [requestId]="requestId" (currentUserAddedChange)="currentUserAddedChange($event)"></app-add-persons>
              <app-flow-navigation [request]="request" [currentTab]="currentTab" [currentStep]="currentTab" [disabled]="header.disableNextButton()" [progress]="progress" (activeTab)="header.getActiveTab($event);"></app-flow-navigation>
            </div>
          </div>
      </div>
      <div class="accordion-item" [ngClass]="{'disabledDiv' : (progress[0] < 100 || progress[1] < 100)}">
        <div class="accordion-header justify-content-between bg-light" id="addActions">
          <div class="p-3" data-bs-toggle="collapse" data-bs-target="#addActions-panel" aria-expanded="false" aria-controls="addActions-panel" (click)="header.getActiveTab('AddActions');">
            <h3 class="mb-0 text-primary" [ngClass]="{active : currentTab === 'AddActions'}">
              <i class="bi bi-3-circle-fill text-primary" [ngClass]="{'text-secondary' : (progress[0] < 100 || progress[1] < 100)}"></i>
              <span [ngClass]="{'text-secondary' : (progress[0] < 100 || progress[1] < 100)}" translate="Request.AddActions"></span>
            </h3>
          </div>
        </div>
        <div id="addActions-panel" class="accordion-collapse collapse indent" aria-labelledby="addActions" data-bs-parent="#accordion">
          <div class="bg-white accordion-body px-3 pb-4 h-100">
            <app-add-actions [hidden]="currentTab !== 'AddActions'" #addActions [request]="request" [workflowData]="workflowData?.step3" 
            [countDocuments]="countDocuments" [countPersons]="countPersons" ></app-add-actions>
            <app-flow-navigation [request]="request" [currentTab]="currentTab" [currentStep]="currentTab" [disabled]="header.disableNextButton()" [progress]="progress" (activeTab)="header.getActiveTab($event);"></app-flow-navigation>
          </div>
        </div>
      </div>
      <div class="accordion-item" [ngClass]="{disabledDiv : (progress[0] < 100 || progress[1] < 100 || progress[2] < 100)}">
          <div class="accordion-header justify-content-between bg-light" id="reviewAndSend">
              <div class="p-3" data-bs-toggle="collapse" data-bs-target="#reviewAndSend-panel" aria-expanded="false" aria-controls="reviewAndSend-panel" (click)="header.getActiveTab('ReviewAndSend');">
                  <h3 class="mb-0 text-primary" [ngClass]="{active : currentTab === 'ReviewAndSend'}">
                      <i class="bi bi-4-circle-fill text-primary" [ngClass]="{'text-secondary' : (progress[0] < 100 || progress[1] < 100 || progress[2] < 100)}"></i>
                      <span [ngClass]="{'text-secondary' : (progress[0] < 100 || progress[1] < 100 || progress[2] < 100)}" translate="Request.ReviewAndSend"></span>
                  </h3>
              </div>
          </div>
          <div id="reviewAndSend-panel" class="accordion-collapse collapse indent" aria-labelledby="reviewAndSend" data-bs-parent="#accordion">
              <div class="bg-white accordion-body px-3 pb-4 h-100">
                <app-reviewandsend *ngIf="!(currentTab !== 'ReviewAndSend')" [request]="request"></app-reviewandsend>
                <app-flow-navigation [request]="request" [currentTab]="currentTab" [currentStep]="currentTab" [disabled]="header.disableNextButton()" [progress]="progress" [enableSendRequestAction]="header.enableSendRequestAction" (sendRequest)="SendRequest($event)"></app-flow-navigation>
              </div>
          </div>
      </div> 
    </div>
  </div>
</div>
-->

<app-mobile-overlay></app-mobile-overlay>